/**
 * --------------------------------------------------------------------------
 * Hive Component: Hive/Handler.js
 * Copyright (c) 2005 - 2023 Paul Höcker / PHMG All rights reserved.
 * Licensed under GNU General Public License version 2 or later
 * --------------------------------------------------------------------------
 */

import Registry from "./components/Registry.js";

/**
 * Constants
 */
const NAME = 'BaseHandler'
const VERSION = '1.0.0'

class Handler {

	/**
	 * Name
	 * @type {string}
	 */
	static NAME = NAME

	/**
	 * Version
	 * @type {string}
	 */
	static VERSION = VERSION

	/**
	 * Utils
	 */
	utils

	/**
	 * Controller instance
	 * @type {Controller|*}
	 */
	Controller

	/**
	 * @type {Registry}
	 */
	Options

	/**
	 * The default options
	 * @type {{}}
	 */
	Defaults = {}

	/**
	 *
	 * @param {Controller|*} controller
	 * @param {*|undefined} [options]
	 */
	constructor(controller, options) {
		this.utils = Hive.getUtils();

		try {
			this.Controller = controller || document;
			// setOptions has to be called in the child class!!!
			this.setOptions(options);
		} catch (exception) {
			this.utils.error(exception.message || 'ERROR');
		}
	}

	setOptions(options) {
		this.Options = new Registry(this.Defaults);
		this.set(options);
	}

	/**
	 * Method to parse the given option(s)
	 * @param {*|{}} options
	 * @returns {{}}
	 */
	parseOptions(options) {
		options = options || {};

		return options;
	}

	/**
	 * Set a single or a set of options
	 * @param {*|{}} options
	 * @returns {Handler}
	 */
	set(options) {
		options = this.parseOptions(options);
		this.Options.load(options);

		return this;
	}

	/**
	 * Get an option
	 * @param {string} key
	 * @param {*} [def]
	 * @returns {*|null}
	 */
	get(key, def) {
		return this.Options.get(key, def);
	}

}

export default Handler